import type { ShortcutHandlerContext } from '../../lib/types.js';
import { sendShortcutJson } from '../../lib/response.js';

/** Bridge-scoped routes must include a matching workspaceId query param. */
export function assertBridgeWorkspace(ctx: ShortcutHandlerContext): boolean {
  const reqWorkspaceId = ctx.url.searchParams.get('workspaceId')?.trim() ?? '';
  if (reqWorkspaceId !== ctx.workspaceId) {
    sendShortcutJson(ctx.res, 403, { error: 'workspaceId mismatch' });
    return false;
  }
  return true;
}
